export class InsaChronosJobModel{
  JobID:number;
  Name: string;
  Description: string; 
  CRONExpression: string = "0 3 2 12 1/1 ? *"; 
  JobLastModifiedTime: Date;
  JobLastModifiedBy: string = "";
  Activities: any;
}


// WEBPACK FOOTER //
// ./app/insa-models/insa-chronos-job.model.ts